import React, {PureComponent as Component} from 'react';
import ContentLoader from 'react-content-loader'

import FormManager from "../../../ui/template/Form/FormManager";
import Submit from "../../../ui/template/Form/Submit";
import Alerts from "../../../ui/template/Alert/Alerts";
import {MCbrowser} from "../../Context/browserContext";
import getBioApi from "./Api/getBio";
import postBioApi from "./Api/postBio";
import TextArea from "../../../ui/template/Input/TextArea";


class  EditBio  extends Component{

    constructor(props) {
        super(props);

        this.HbioChange = this.bioChange.bind(this);
        
        this.handlePostUp = this.postUp.bind(this);
        this.state = {isload: false, isClose: false};
        this.values = {  bio: ''  };
        this.form1=React.createRef();
        this.formAlerts=React.createRef();
        this.getLoadForm = this.getLoad.bind(this);
        this.components= {
            bio: React.createRef(),

        };
        this.props=props;
    }

    bioChange(e) {
        this.values.bio= e.target.value;
        return true;
    }

    

    async postUp() {
        let pageAlerts = this.context.page.pageAlerts;
        let l=await postBioApi(this.values.bio , pageAlerts,this.formAlerts);
        if(l===true){

        }
    }

    async getLoad() {
        let data=await getBioApi();
        if(data===false){
            this.setState({isloadData:true});
        }else{
            let components=this.components;
            this.setState({isload: true, isClose: false});

            if(data.bio!=null) this.values.bio = data.bio;

            Object.keys(this.components).forEach(element => {
                if (data.hasOwnProperty(element)) {
                    if(data[element]!=null) components[element].current.setValue(data[element]);
                }
            });
        }
    }

    componentDidMount(){
        this.getLoadForm();
    }

    render() {
        if (this.state.isload) {
            return ( <FormManager   ref={this.form1} submit={this.handlePostUp}>
                            <div className="border rounded bg-white mb-3">
                                <div className="box-title border-bottom p-3">
                                    <h6 className="m-0">
                                        درباره من
                                    </h6>
                                    <p className="mb-0 mt-0 small">
                                        آنچه که درباره خود می خواهید را در چند خط بنویسید
                                    </p>
                                </div>
                                <div className="box-body">
                                    <div className="p-3 border-bottom">
                                        <div className="form-group mb-4">
                                            <label className="mb-1">
                                                بیوگرافی
                                            </label>
                                            <div className="position-relative">.
                                                <TextArea   className="form-control" rows="4"
                                                             placeholder="بیوگرافی ... "
                                                             onChange={this.HbioChange} ref={this.components.bio} />
                                            </div>
                                        </div>
                                        <Alerts layout="relative" ref={this.formAlerts} />
                                    </div>
                                    <div className="overflow-hidden text-center p-3">
                                        <Submit className="font-weight-bold btn btn-light rounded p-3 d-block w-100"  >
                                            ذخیره
                                        </Submit>
                                    </div>
                                </div>
                            </div>
                    </FormManager>);
        }else{
            return (    <div className="border rounded bg-white mb-3">
                            <div className="box-title border-bottom p-3">
                                <h6 className="m-0">
                                    درباره من
                                </h6>
                            </div>
                            <div className="box-body">
                                <ContentLoader width="100%" height="100px">
                                    <rect x="10%" y="10" rx="5" ry="5" width="75%" height="70" />
                                </ContentLoader>
                            </div>
                        </div> );
        }
    }
}

EditBio.contextType = MCbrowser;

export default EditBio;
